export default __webpack_public_path__ + "static/4-83860af975c1a11db50f563ba7ef2a3d.png";